export const getAuthParams = () => { 
  const user = localStorage.getItem('user');
  return user && JSON.parse(user);
};
